export class RepairsImportModel {
    counter: number = 0;
    companyId: number = 0;
    branchId: number = 0;
    maintenanceOrderClass: number = 0;
    maintenanceOrderNumber: number = 0;
    equipmentCode: number = 0;
    detailRepair: string | null = null;
    quantity: number = 0;
    unitValue: number = 0;

    constructor(counter: number,
        companyId: number, branchId: number,
        maintenanceOrderClass: number,
        maintenanceOrderNumber: number,
        equipmentCode: number,
        detailRepair: string | null,
        quantity: number,
        unitValue: number) {
        this.counter = counter;
        this.companyId = companyId;
        this.branchId = branchId;
        this.maintenanceOrderClass = maintenanceOrderClass;
        this.maintenanceOrderNumber = maintenanceOrderNumber;
        this.equipmentCode = equipmentCode;
        this.detailRepair = detailRepair;
        this.quantity = quantity;
        this.unitValue = unitValue;
    }
}